import { baseResources, baseResourceActions } from "routes/enum";

const {
    KB_CAPSULE_SETTINGS,
    KB_CLASS,
    KB_CLASS_ATTACHMENT,
    KB_CLASS_FORMAT,
} = baseResources;

const { READ, CREATE, UPDATE } = baseResourceActions;

/** View capsule settings */
export const CAPSULE_SETTINGS_READ_PERMISSION = [`${READ}_${KB_CAPSULE_SETTINGS}`];

/** Add new classes */
export const CLASS_CREATE_PERMISSION = [`${CREATE}_${KB_CLASS}`];

/** Attach classes */
export const CLASS_ATTACHMENT_PERMISSION = [`${UPDATE}_${KB_CLASS_ATTACHMENT}`];

/** Edit class formatting */
export const CLASS_FORMAT_PERMISSION = [`${UPDATE}_${KB_CLASS_FORMAT}`];

export const CONTENT_STRUCTURE_PERMISSION_MAP = {
    "View capsule settings": CAPSULE_SETTINGS_READ_PERMISSION,
    "Add new classes": CLASS_CREATE_PERMISSION,
    "Attach classes": CLASS_ATTACHMENT_PERMISSION,
    "Edit class formatting": CLASS_FORMAT_PERMISSION,
};
